export default "__VITE_ASSET__7e1d76e8__"